angular
    .module("tableFilter.components", [])
    .component("tableFilter", {
        templateUrl: "ng/components/tableFilter/tableFilter.html",
        bindings: {
            output: "&"
        },
        controllerAs: "tableFilterCtrl",
        controller: function ControllerTableFilter($typeDomainService) {
            var self = this;


            self.$onInit = function () {

                self.getTransactionStatusList();
                self.mapTransactionStatus = [];
                self.filter = {
                    status: "",
                    cf: ""
                }
            }

            self.onStatus = function (status) {
                self.filter.status = status
            }

            self.onCf = function (cf) {
                self.filter.cf = cf
            }


            self.onFilterChange = function () {
                console.log("Stato inviato: " + self.filter.cf + "    " + self.filter.status);
                self.output && self.output({
                    filter: self.filter
                })
            }

            self.clearSelection = function (filter, field) {
                filter[field] = '';
                if (field == 'self.filter.status') {
                    filter = '';
                }
            }


            self.getTransactionStatusList = function () {
                $typeDomainService.getDomainSet('APP_IL_TRANSACTION', 'TRANSACTION_STATUS')
                    .then(function (response) {

                        self.mapTransactionStatus = response.domainList.filter(function (item) {
                            return item.value >= 70;
                        });
                    });
            }

        }


    });